import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { end: Number }

  connect() {
    const format = new Intl.NumberFormat()
    const end = Math.max(0, this.endValue)
    if (matchMedia("(prefers-reduced-motion: reduce)").matches || document.hidden || end === 0) {
      this.element.textContent = format.format(end)
      return
    }

    const start = performance.now()
    const tick = (now) => {
      const progress = Math.min((now - start) / 700, 1)
      this.element.textContent = format.format(Math.round(end * (1 - (1 - progress) ** 3)))
      if (progress < 1) this.frame = requestAnimationFrame(tick)
    }
    this.element.textContent = "0"
    this.frame = requestAnimationFrame(tick)
  }

  disconnect() {
    cancelAnimationFrame(this.frame)
  }
}
